import { ApiBase } from '@bymason/api-base';
import { RequestDeviceFormFields } from './types';

export * from './types';

class RequestDeviceForm extends ApiBase {
  private static instance: RequestDeviceForm;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns An RequestDeviceForm instance
   */
  public static getInstance(): RequestDeviceForm {
    if (!RequestDeviceForm.instance) {
      RequestDeviceForm.instance = new RequestDeviceForm();
      RequestDeviceForm.instance.configure({
        fleet: 'global',
      });
    }

    return RequestDeviceForm.instance;
  }

  /**
   * Creates an account.
   * @param options model data required to create an account.
   * @param clientToken token required for proper authorization.
   * @returns void
   */
  public async submit(options: RequestDeviceFormFields, clientToken: string) {
    const urlTemplate = this.getEndpointTemplate('account/request-device');
    const url = this.expandUrlParams(urlTemplate, options);

    const dataResponse = await this.callVoidEndpoint({
      clientToken,
      body: JSON.stringify(options),
      method: 'POST',
      url,
    });

    return dataResponse;
  }
}

export const requestDeviceFormClient = RequestDeviceForm.getInstance();
